import Sentence from "../model/Sentence";
import { getUid } from "../../auth/AuthManager";
import {
  getLanguageCode,
  getLanguageString,
} from "../manager/sentenceSettings";
import getApiInstance from "../../common/api";
import OnevocaServerError from "../../common/OnevocaServerError";

export async function fetchSentence(word: string): Promise<Sentence> {
  try {
    const uid = await getUid();
    const languageCode = getLanguageCode();
    const languageString = getLanguageString();

    const response = await getApiInstance(undefined).get(
      `/sentence/getSentence.php?uid=${uid}&requestWord=${word}&requestLanguage=${languageCode}&requestLanguageLocalizedString=${languageString}`
    );

    const error = response.data.error;
    if (error !== undefined) {
      return Promise.reject(new OnevocaServerError(error));
    }

    const data = response.data.data;

    if (data === undefined) {
      return Promise.reject("No data.");
    }

    const sentence = Sentence.fromJson(data);
    return sentence;
  } catch (error) {
    return Promise.reject(error);
  }
}
